var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5347 0.615234C29.6459 0.615234 33.5 4.78551 33.5 10.3157V20.8573C33.5 23.6876 32.4993 26.2447 30.6804 28.059C29.0488 29.6844 26.9322 30.5455 24.5593 30.5455H9.43609C7.06777 30.5455 4.9527 29.6859 3.31958 28.059C1.50074 26.2447 0.5 23.6876 0.5 20.8573V10.3157C0.5 4.78551 4.35409 0.615234 9.46526 0.615234H24.5347ZM24.5347 2.91756H9.46526C5.60502 2.91756 2.80233 6.02877 2.80233 10.3157V20.8573C2.80233 23.0721 3.56363 25.0506 4.94502 26.4274C6.13609 27.6169 7.69093 28.2431 9.4407 28.2431H24.5347C24.5378 28.2401 24.5501 28.2431 24.5593 28.2431C26.3106 28.2431 27.8639 27.6169 29.055 26.4274C30.4379 25.0506 31.1977 23.0721 31.1977 20.8573V10.3157C31.1977 6.02877 28.395 2.91756 24.5347 2.91756ZM26.9537 10.0222C27.3543 10.5149 27.2791 11.2394 26.7864 11.6415L19.9654 17.1855C19.1028 17.8701 18.0714 18.2124 17.0414 18.2124C16.0146 18.2124 14.9908 17.8732 14.1344 17.1947L7.25042 11.6446C6.75465 11.2455 6.67791 10.5195 7.07544 10.0253C7.47605 9.5326 8.20051 9.45432 8.69475 9.85186L15.5726 15.3959C16.4367 16.0804 17.6539 16.0804 18.5241 15.3897L25.3329 9.85493C25.8271 9.45125 26.5516 9.528 26.9537 10.0222Z",
    fill: "#1290E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fe381d503c466917c8980cbba85d4f21.svg";
export { ForwardRef as ReactComponent };